"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDeviseDiy;
var _store = _interopRequireDefault(require("../store"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function useDeviseDiy(param) {
  var _this = this;
  //中间页点击隐藏模块；
  var bindHide = function bindHide(item, key) {
    _this.$nextTick(function () {
      _this.$set(_this.mConfig[key], 'isShow', !_this.mConfig[key].isShow);
    });

    //this.mConfig[key].isShow = !this.mConfig[key].isShow
    _store.default.commit('mobildConfig/UPDATESHOW', item);
  };
  //移动事件
  var onMove = function onMove(e) {
    if (e.relatedContext.element.name == 'search_box') return false;
    if (e.relatedContext.element.name == 'nav_bar') return false;
    return true;
  };

  // 对象转数组
  var objToArr = function objToArr(data) {
    var obj = Object.keys(data).sort();
    var m = obj.map(function (key) {
      return data[key];
    });
    return m;
  };
  return {
    bindHide: bindHide,
    onMove: onMove,
    objToArr: objToArr
  };
}